import { FormBuilder, Validators } from '@angular/forms';
import { Component,  OnInit, Output, ViewEncapsulation, EventEmitter, ViewChild } from '@angular/core';
import { DxDropDownBoxComponent } from 'devextreme-angular/ui/drop-down-box';
import { AdvanceDashboardService } from '../../bi-dashboard/dashboard.service';


@Component({
    selector: 'app-new-post-popup',
    templateUrl: './new-post-popup.component.html',
    styleUrls: ['./new-post-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewPostPopupComponent implements OnInit {
	@Output() public onClose = new EventEmitter();
	@Output() public onSave = new EventEmitter();

	public title = "Create New Post";
	icondata: any;
	icon: any;

	public form = this.formBuilder.group(
		{
			previewTitle: [undefined, [Validators.required, Validators.maxLength(512)]],
			previewDescription: [undefined, [Validators.maxLength(2048)]],
			icon: ["", [Validators.maxLength(128)]],
			isPriority: [false],
			htmlText: [undefined],
		}
	);

	public controls = {
		previewTitle: this.form.get("previewTitle"),
		previewDescription: this.form.get("previewDescription"),
		icon: this.form.get("icon"),
		isPriority: this.form.get("isPriority"),
		htmlText: this.form.get("htmlText"),
	};

	constructor(private formBuilder: FormBuilder,
		private dashboardService: AdvanceDashboardService
	) {}

	ngOnInit() {
		this.getIcons();
	}

	public onCreateNewPost() {
		if (this.form.invalid) {
			return;
		}

		this.onSave.emit(this.form.value);
	}

	@ViewChild("dropDownBoxInstance", { static: false }) dropDownBoxInstance: DxDropDownBoxComponent;

	getIcons() {
		this.dashboardService.GetIcons().subscribe(response => {
			this.icondata = response;
		});
	}

	onSelectionChanged(e) {
		if (e.selectedRowsData && e.selectedRowsData[0] != null && e.selectedRowsData[0] != undefined) {
			this.icon = e.selectedRowsData[0];
		}
		this.dropDownBoxInstance.instance.close();
	}
}
